import { Component } from '@verndale/core';
import Player from '@vimeo/player';

class Video extends Component {
  player: Player | undefined;
  observer: IntersectionObserver | undefined;
  options: {
    autoplay: boolean;
    loop: boolean;
    muted: boolean;
    noControls: boolean;
  };

  constructor(el: HTMLElement) {
    super(el);

    this.options = {
      autoplay: el.dataset.autoplay === 'true',
      loop: el.dataset.loop === 'true',
      muted: el.dataset.muted === 'true',
      noControls: el.dataset.noControls === 'true'
    };

    console.log(this.options);

    this.setupObserver();
  }

  setupDefaults() {
    this.dom = {
      thumbnail: this.el.querySelector<HTMLElement>('.video__media-image'),
      videoContainer: this.el.querySelector<HTMLElement>('.video__media-video-container'),
      playButton: this.el.querySelector<HTMLElement>('.video__play-button'),
      pauseButton: this.el.querySelector<HTMLElement>('.video__pause-button'),
      iframe: this.el.querySelector<HTMLIFrameElement>('.video__media-video-container iframe')
    };
  }

  setupObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const isVisible = getComputedStyle(this.el).display !== 'none';

            if (isVisible) {
              setTimeout(() => {
                this.initVideo();
              }, 100);
              this.observer?.disconnect();
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px 200px 0px'
      }
    );

    this.observer.observe(this.el);
  }

  initVideo() {
    this.player = new Player(this.dom.iframe as HTMLIFrameElement);
    this.player.ready().then(() => {
      if (this.options.autoplay) {
        this.player?.play();
        (this.dom.playButton as HTMLElement).setAttribute('hidden', 'true');
        (this.dom.pauseButton as HTMLElement).removeAttribute('hidden');

        (this.dom.thumbnail as HTMLElement).setAttribute('hidden', 'true');
        (this.dom.videoContainer as HTMLElement).removeAttribute('hidden');
      }
    });

    this.player?.on('pause', () => {
      (this.dom.pauseButton as HTMLElement).setAttribute('hidden', 'true');
      (this.dom.playButton as HTMLElement).removeAttribute('hidden');
    });

    this.player?.on('play', () => {
      (this.dom.playButton as HTMLElement).setAttribute('hidden', 'true');
      (this.dom.pauseButton as HTMLElement).removeAttribute('hidden');
    });

    this.addPlayerListeners();
  }

  addPlayerListeners() {
    (this.dom.playButton as HTMLElement)?.addEventListener('click', this.handlePlay.bind(this));
    (this.dom.pauseButton as HTMLElement)?.addEventListener('click', this.handlePause.bind(this));
  }

  handlePlay() {
    if (!this.player) {
      return;
    }
    this.player.play();
  }

  handlePause() {
    if (!this.player) {
      return;
    }
    this.player.pause();
  }
}

export default Video;
